import Vue from 'vue'
import Vuex from 'vuex'
import { VUE_APP_WS_URL } from '../config.js'
import i18n from '@/common/lang';
import { login } from '@/api/login.js'
import { getUserInfo } from "@/api/user";
import { listContents } from '@/api/market'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    innerWidth: 0,
    wsUrl: VUE_APP_WS_URL+"/message",
    marketWsList: [],
    currentLanguage: localStorage.getItem('language')||'en',
    //不显示底部导航的页面
    footerWhiteList: ["reset", "login", "register"],
    lginWhiteList: ["google"],
    isLogin: localStorage.getItem('isLogin')||false,
    isPc: true,
    userInfo: localStorage.getItem('userInfo')? JSON.parse(localStorage.getItem('userInfo')):{},
    token: localStorage.getItem('token')||'',
    contentsList: [],
    langIndex: 0,
    langList: [
      // 'zh': Object.assign(require('@/common/lang/zh-CN'), zhLocale),
      // 'en': Object.assign(require('@/common/lang/en'), enLocale),
      // 'ja': Object.assign(require('@/common/lang/ja'), enLocale),
      // 'ko': Object.assign(require('@/common/lang/ko'), enLocale),
      // 'de': Object.assign(require('@/common/lang/de'), enLocale),
      // 'fr': Object.assign(require('@/common/lang/fr'), enLocale),
      // 'it': Object.assign(require('@/common/lang/it'), enLocale),
      // 'ar': Object.assign(require('@/common/lang/ar'), enLocale),
      // 'hk': Object.assign(require('@/common/lang/zh-HK'), enLocale),
      // 'es': Object.assign(require('@/common/lang/es'), enLocale),
      {
        name: 'English',
        value: 'en'
      },
      {
        name: '日本語',
        value: 'ja'
      },
      {
        name: '한국어',
        value: 'ko'
      },
      {
        name: 'Deutsch',
        value: 'de'
      },
      {
        name: 'français',
        value: 'fr'
      },
      {
        name: 'Italiano',
        value: 'it'
      },
      {
        name: 'Español',
        value: 'es'
      },
      {
        name: 'العربية',
        value: 'ar'
      },
      {
        name: '繁體中文',
        value: 'hk'
      },
      {
        name: '简体中文',
        value: 'zh'
      },
    ],
    areaCodes: [
      // hot markets first (+1 fixed at top), and +86 excluded by request
      "+1", "+44", "+81", "+82", "+852", "+886", "+65", "+61", "+64", "+49", "+33", "+39", "+34", "+31",
      "+41", "+46", "+47", "+45", "+90", "+971", "+966", "+974", "+972", "+91", "+92", "+94", "+84", "+62",
      "+60", "+66", "+63", "+55", "+52", "+54", "+57", "+58", "+20", "+27", "+7",
      "+30", "+32", "+36", "+40", "+43", "+48", "+51", "+53", "+56", "+93", "+95", "+98", "+211",
      "+212", "+213", "+216", "+218", "+220", "+221", "+222", "+223", "+224", "+225", "+226", "+227",
      "+228", "+229", "+230", "+231", "+232", "+233", "+234", "+235", "+236", "+237", "+238", "+239",
      "+240", "+241", "+242", "+243", "+244", "+245", "+246", "+248", "+249", "+250", "+251", "+252",
      "+253", "+254", "+255", "+256", "+257", "+258", "+260", "+261", "+262", "+263", "+264", "+265",
      "+266", "+267", "+268", "+269", "+290", "+291", "+297", "+298", "+299", "+350", "+351", "+352",
      "+353", "+354", "+355", "+356", "+357", "+358", "+359", "+370", "+371", "+372", "+373", "+374",
      "+375", "+376", "+377", "+378", "+380", "+381", "+382", "+383", "+385", "+386", "+387", "+389",
      "+420", "+421", "+423", "+500", "+501", "+502", "+503", "+504", "+505", "+506", "+507", "+508",
      "+509", "+590", "+591", "+592", "+593", "+594", "+595", "+596", "+597", "+598", "+599", "+670",
      "+672", "+673", "+674", "+675", "+676", "+677", "+678", "+679", "+680", "+681", "+682", "+683",
      "+685", "+686", "+687", "+688", "+689", "+690", "+691", "+692", "+850", "+853", "+855", "+856",
      "+880", "+960", "+961", "+962", "+963", "+964", "+965", "+967", "+968", "+970", "+973", "+975",
      "+976", "+977", "+992", "+993", "+994", "+995", "+996", "+998"
    ],
    virtualStatus: localStorage.getItem('virtualStatus')||1,
    showBoard: sessionStorage.getItem('showBoard') || 0,
  },
  getters: {
    marketWsList: state => state.marketWsList,
    getMarkTypeList: () => {
      return [
        {
          label: i18n.t('Market.forex'),
          value: "1",
        },
        {
          label: i18n.t('Market.cypto'),
          value: "2"
        },
        {
          label: i18n.t('Market.stocks'),
          value: "3"
        },
        {
          label: i18n.t('Market.futures'),
          value: "4"
        },
        {
          label: i18n.t('Market.ETF'),
          value: "5"
        }
      ]
    },
    getContentList: state => state.contentsList,
    getUserInfo: state => state.userInfo,
    langList: state => state.langList,
    langIndex: state => state.langIndex,
    virtualStatus: state => state.virtualStatus,
  },
  mutations: {
    set_isLogin(state, val) {
      state.isLogin=val;
    },
    set_userInfo(state, val) {
      state.userInfo=val;
    },
    SetInnerWidth(state, val) {
      state.innerWidth=val
    },
    CHANGE_WS_MARLET(state, data) {
      state.marketWsList=data;
    },
    changeVirtual(state, val) {
      state.virtualStatus=val;
      localStorage.setItem('virtualStatus', val);
    },
    SET_LANG(state, language) {
      localStorage.setItem('language', language);
      state.currentLanguage=language;
      state.langIndex=state.langList.findIndex((item) => item.value===state.currentLanguage);
      // console.log(state.langIndex);
      // 更新 i18n 的当前语言
      // console.log(i18n);
      i18n.locale=language;



      // state.marketTypeList = state.marketTypeList
    },
    SET_IS_PC(state, val) {
      state.isPc=val;
    },
    SET_CONTENTS(state, val) {
      state.contentsList=val;
    },
    setToken(state, token) {
      state.token=token;
    },
    setShowBoard(state, val) {
      state.showBoard=val;
      sessionStorage.setItem('showBoard', val);
    }
  },
  actions: {
    listContents({ commit, state }, lang) {
      return new Promise((resolve, reject) => {
        listContents(lang).then(res => {
          if (res.code=='200') {
            commit('SET_CONTENTS', res.result);
          }
          resolve(res);
        }).catch(err => {
          reject(err);
        })
      })
    },
    loginOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        localStorage.removeItem('token')
        localStorage.removeItem('userInfo')
        localStorage.removeItem('isLogin')
        commit('setToken', '')
        commit('set_isLogin', false)
        commit('set_userInfo', {})
        resolve();
      })
    },
    login({ commit, state }, params) {
      return new Promise((resolve, reject) => {
        login(params).then(res => {
          if (res.code=='200') {
            localStorage.setItem('token', res.result.token)
            localStorage.setItem('userInfo', JSON.stringify(res.result))
            localStorage.setItem('isLogin', true)
            commit('setToken', res.result.token)
            commit('set_isLogin', true)
            commit('set_userInfo', res.result)
          }
          resolve(res);
        }).catch(err => {
          reject(err);
        })
      })
    },

    walletLoginSuccess({ commit }, userInfo) {
      // 保存登录信息
      localStorage.setItem('token', userInfo.token);
      localStorage.setItem('userInfo', JSON.stringify(userInfo));
      localStorage.setItem('isLogin', true);

      // 更新 Vuex 状态
      commit('setToken', userInfo.token);
      commit('set_isLogin', true);
      commit('set_userInfo', userInfo);

      return userInfo;
    },

    GET_USER_INFO({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUserInfo().then(res => {
          if (res.code=='200') {
            // localStorage.setItem('token', res.result.token)
            localStorage.setItem('userInfo', JSON.stringify(res.result))
            localStorage.setItem('isLogin', true)
            // commit('setToken', res.result.token)
            commit('set_isLogin', true)
            commit('set_userInfo', res.result)
          }
          resolve(res);
        }).catch(err => {
          reject(err);
        })
      })
    },
    GET_WS_MARKET({ commit, state }) {
      console.log(state.wsUrl);
      try {
        return new Promise((resolve, reject) => {
          const ws=new WebSocket(state.wsUrl);
          ws.onopen=() => {
            console.log("Connect Success");
            resolve("连接成功");
          };
          ws.onmessage=e => {
            if (e.data.includes("[")) {
              const data=JSON.parse(e.data);
              commit('CHANGE_WS_MARLET', data);
            }
          };
          ws.onclose=() => {
            console.log("连接关闭");
          };
          ws.onerror=() => {
            console.log("连接出错");
            reject("连接出错");
          };
        })
      } catch (error) {
        console.error('捕获到异常: '+error.message);
        reject("连接出错");
      }
    }
  },
  modules: {
  }
})
